import { useState, useEffect } from 'react';
import { generateTotpCode } from 'shared/utils/totp';

export const TOTP_STEP = 20;

export function secondsUntilNextStep(step) {
  return step - (Math.floor(Date.now() / 1000) % step);
}

export function useTotpCode(secret, { step }) {
  const [code, setCode] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!secret || !step) {
      setCode(null);
      return undefined;
    }

    let lastBucket = -1;

    const tick = () => {
      const bucket = Math.floor(Date.now() / 1000 / step);
      if (bucket === lastBucket) return;
      lastBucket = bucket;
      try {
        setCode(generateTotpCode(secret, { period: step }));
        setError(null);
      } catch (e) {
        setCode(null);
        setError(e);
      }
    };

    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [secret, step]);

  return { code, error };
}
